const EMPTY_PRICE_FIELD = {
  price: 0,
  capacity: 0,
  sportId: null,
};

const DEFAULT_PRICE_LIST = [EMPTY_PRICE_FIELD];

export { DEFAULT_PRICE_LIST, EMPTY_PRICE_FIELD };
